import React from 'react';
/**
 * DjayAvatar part — tier flair (pro band / master crown + cape).
 * Verbatim extraction of the former `renderTierElements()`. The `uid` keeps
 * gradient ids unique across simultaneously-rendered avatars.
 */
import type { DjayTier } from '../types';
interface TierElementsProps {
  tier: DjayTier;
  uid: string;
  showDetails: boolean;
}
export function TierElements({
  tier,
  uid,
  showDetails
}: TierElementsProps) {
  if (!showDetails) return null;
  switch (tier) {
    case 'pro':
      return <g className="djay-tier-pro" data-id="element-3280">
          <path d="M45 75 Q100 85 155 75 L150 65 Q100 75 50 65 Z" fill="#3B82F6" data-id="element-3281" />
          <path d="M45 75 Q100 85 155 75 L150 65 Q100 75 50 65 Z" fill={`url(#${uid}-pro-band-grad)`} opacity="0.5" data-id="element-3282" />
          <path d="M145 70 L165 60 L160 75 Z" fill="#2563EB" data-id="element-3283" />
          <defs data-id="element-3284">
            <linearGradient id={`${uid}-pro-band-grad`} x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-3285">
              <stop offset="0%" stopColor="#1D4ED8" data-id="element-3286" />
              <stop offset="50%" stopColor="#60A5FA" data-id="element-3287" />
              <stop offset="100%" stopColor="#1D4ED8" data-id="element-3288" />
            </linearGradient>
          </defs>
        </g>;
    case 'master':
      return <g className="djay-tier-master" data-id="element-3289">
          <path d="M60 55 L70 25 L85 45 L100 15 L115 45 L130 25 L140 55 Z" fill="#FBBF24" stroke="#D97706" strokeWidth="2" strokeLinejoin="round" data-id="element-3290" />
          <circle cx="70" cy="25" r="4" fill="#EF4444" data-id="element-3291" />
          <circle cx="100" cy="15" r="5" fill="#3B82F6" data-id="element-3292" />
          <circle cx="130" cy="25" r="4" fill="#10B981" data-id="element-3293" />
          <path d="M65 50 Q100 60 135 50" fill="none" stroke="#D97706" strokeWidth="2" data-id="element-3294" />
          <path d="M40 120 Q20 150 30 190 L60 180 Q45 140 50 120 Z" fill="#7C3AED" data-id="element-3295" />
          <path d="M160 120 Q180 150 170 190 L140 180 Q155 140 150 120 Z" fill="#7C3AED" data-id="element-3296" />
          <path d="M45 125 Q100 145 155 125 L150 115 Q100 135 50 115 Z" fill="#6D28D9" data-id="element-3297" />
        </g>;
    default:
      return null;
  }
}